export default "__VITE_ASSET__Cd82lrOc__"